const isServer = (): boolean => {
  return !(typeof window != "undefined" && window.document);
};

export default isServer;
